import React from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { deslugify } from 'helpers/text';

// components
import LocationHeader from 'components/LocationHeader';
import Carousel from 'components/Carousel';
import Nearby3Up from 'components/Nearby3Up';
import LocationJobCardGrid from 'components/LocationJobCardGrid';
import Contact from 'components/Contact';
import NavigationThemeSetter from 'components/NavigationThemeSetter';
import Meta from 'components/Meta';

import { get } from 'helpers/utilities';
import buildGTMData from 'helpers/buildGTMData';

import useLocationContent from '../../hooks/useLocationContent';
import useContact from '../../hooks/useContact';

const Location = ({ active }) => {
  const params = useParams();
  const { pathname } = useLocation();
  const locationContent = useLocationContent(params.location);
  const gtmData = buildGTMData(locationContent);
  const contactData = useContact(locationContent);

  if (!locationContent) return null;
  if (locationContent.uri !== pathname.slice(1)) return null;

  const { slug, locationHeader, officeLocation, locationCarousel, locationNearby3Up } =
    locationContent;
  const metaDetails = {
    metaSection: get(locationContent, 'socialMetaSection[0]'),
    entryTitle: get(locationContent, 'title'),
    placeholderImage: get(locationContent, 'locationHeader[0]headerBackground[0].url')
  };
  return (
    <>
      <Meta metaDetails={metaDetails} active={active} gtm={gtmData} />
      <NavigationThemeSetter navTheme="header">
        <LocationHeader {...locationHeader[0]} officeLocation={officeLocation} />
      </NavigationThemeSetter>
      {locationCarousel && locationCarousel.length ? (
        <NavigationThemeSetter navTheme="black">
          <Carousel data={locationCarousel[0]} type="location" />
        </NavigationThemeSetter>
      ) : null}
      {locationNearby3Up && locationNearby3Up.length ? (
        <NavigationThemeSetter navTheme="white">
          <Nearby3Up {...locationNearby3Up[0]} />
        </NavigationThemeSetter>
      ) : null}
      <NavigationThemeSetter navTheme="black">
        <LocationJobCardGrid location={deslugify(slug)} />
      </NavigationThemeSetter>
      <NavigationThemeSetter navTheme="white">
        <Contact {...contactData} isMinified={false} />
      </NavigationThemeSetter>
    </>
  );
};

export default Location;
